<template>
  <div class="OfflineIndicator">
    <div class="OfflineIndicator_Inner" v-if="isOffline">
      Offline. Your changes will sync when you reconnect.
    </div>
    <div
      class="OfflineIndicator_Inner m-online"
      v-if="!isOffline && !$store.state.isInIframe"
    >
      Changes are saved automatically
    </div>
  </div>
</template>

<script lang="ts">
import WBComponent from "@/WBComponent";
import { Component } from "vue-property-decorator";

@Component
export default class OfflineIndicator extends WBComponent {
  get isOffline(): boolean {
    return this.state.reported.isOffline;
  }
}
</script>

<style scoped lang="scss">
.OfflineIndicator {
  pointer-events: none;
  position: fixed;
  display: flex;
  justify-content: center;
  bottom: 5px;
  left: 0;
  right: 0;

  @media (max-width: 768px) {
    bottom: 55px;
    text-align: center;
  }
}

.OfflineIndicator_Inner {
  background-color: var(--bg-light);
  color: var(--text-supplemental);
  padding: 3px;

  &.m-online {
    color: var(--text-dark-hint);
  }
}
</style>
